import React, { useState } from "react";
import theme from "../../../styles/theme";

const TabsNavVertical = ({ labels, activeIndex, onChange }) => {
  const [hovered, setHovered] = useState(null);

  const bgHover    = theme.colors.background.hover;
  const textActive = theme.colors.text.primary;
  const textIdle   = theme.colors.text.third;
  const gap        = theme.spacing.xs;   // espacement vertical réduit
  const padY       = theme.spacing.sm;
  const padX       = theme.spacing.md;
  const radius     = theme.borders.radius.md;
  const fwMedium   = theme.fontWeights.normal;
  const fwSelected = theme.fontWeights.selected;
  const font       = theme.fonts.primary;
  const bgSelected = theme.colors.background.selected;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap, // espacement uniforme entre TOUS les éléments (items + séparateurs)
        justifyContent: "flex-start",
        alignItems: "stretch",
        padding: padY,
      }}
    >
      {labels.map((tab, index) => {
        // Séparateur
        if (tab.type === "separator") {
          return (
            <div
              key={"sep-" + index}
              style={{
                height: 1,
                backgroundColor: theme.colors.borders.default,
                opacity: 0.5,
                pointerEvents: "none",
              }}
            />
          );
        }

        const data = typeof tab === "string" ? { label: tab } : tab;
        const isActive = index === activeIndex;
        const isHover  = hovered === index;

        return (
          <div
            key={index}
            onClick={() => onChange(index)}
            onMouseEnter={() => setHovered(index)}
            onMouseLeave={() => setHovered(null)}
            style={{
              cursor: "pointer",
              padding: `${padY}px ${padX}px`,
              borderRadius: radius,
              backgroundColor: isActive
                ? bgSelected
                : isHover
                ? bgHover
                : "transparent",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: theme.spacing.sm,
              transition: "background-color 0.2s ease, color 0.2s ease, transform 0.2s ease",
              userSelect: "none",
            }}
          >
            {data.icon && (
              <img
                src={data.icon}
                alt={`${data.label}-icon`}
                style={{
                  width: 18,
                  height: 18,
                  filter: "none",
                  transform: isHover ? "scale(1.15)" : "scale(1)",
                  transition: "transform 0.2s ease",
                }}
              />
            )}

            <span
              style={{
                fontFamily: font,
                fontWeight: isActive ? fwSelected : fwMedium,
                color: isActive ? textActive : isHover ? textActive : textIdle,
                whiteSpace: "nowrap",
                paddingLeft: 5,
              }}
            >
              {data.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default TabsNavVertical;
